<template>
  <div class="onboarding-indicator">
    <div
      v-for="(isActive, index) in indicators"
      :key="index"
      class="indicator-dot"
      :class="{ active: isActive }"
      :style="{ animationDelay: `${index * 0.1}s` }"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  indicators: boolean[]; // 각 dot의 활성화 여부 배열
}>();
</script>

<style scoped lang="scss">
.onboarding-indicator {
  position: absolute;
  top: 1.5rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  z-index: 10;
}

.indicator-dot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background-color: var(--surface-gray);
  opacity: 0;
  transform: scale(1);
  animation: appearDot 0.2s ease forwards;
}

.indicator-dot.active {
  background-color: var(--surface-primary);
}

@keyframes appearDot {
  to {
    opacity: 1;
  }
}
</style>
